import styled, { css } from 'styled-components';

import { media } from 'src/styles/breakpoints';

export const StyledSearchBar = styled.div<{ $toolbar?: boolean }>`
  display: flex;
  align-items: center;
  gap: ${({ $toolbar }) => ($toolbar ? '0.75rem' : '1rem')};
  width: ${({ $toolbar }) => ($toolbar ? 'auto' : '100%')};
  min-width: 0;
  flex: ${({ $toolbar }) => ($toolbar ? '0 1 auto' : '1 1 auto')};

  ${media.md} {
    flex-direction: ${({ $toolbar }) => ($toolbar ? 'row' : 'column')};
    flex-wrap: ${({ $toolbar }) => ($toolbar ? 'nowrap' : 'nowrap')};
    gap: ${({ $toolbar }) => ($toolbar ? '0.5rem' : '0.75rem')};
    width: ${({ $toolbar }) => ($toolbar ? 'auto' : '100%')};
    flex: ${({ $toolbar }) => ($toolbar ? '1 1 auto' : '1 1 auto')};
    min-width: 0;
  }

  ${({ $toolbar }) =>
    $toolbar
      ? css`
          & > *:first-child {
            flex: 1 1 14rem;
            width: 16rem;
            max-width: 18rem;
            min-width: 11rem;
            margin-bottom: 0;
          }

          & > *:last-child {
            flex: 0 0 8.5rem;
            width: 8.5rem;
            min-width: 7.5rem;
            margin-bottom: 0;
          }

          ${media.md} {
            & > *:first-child {
              flex: 1 1 0;
              width: auto;
              max-width: none;
              min-width: 0;
            }

            & > *:last-child {
              flex: 0 0 6.25rem;
              width: 6.25rem;
              min-width: 5.5rem;
            }
          }
        `
      : css`
          & > * {
            flex: 1 1 12rem;
            min-width: 0;
          }
        `}
`;
